module.exports = __webpack_public_path__ + "img/35.f10baf30.png";